import styled from 'styled-components';
import Burger from './Burger';
import './Navbar.css';
import PICS from '../../assets/images'





const header = styled.nav`
  width: 100%;
  height: 65px;
  border-bottom: 2px solid #1A2A6C;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #f1f1f1;
  opacity: 80%;


  .logo {
    padding-left: 15px;
  }
`

const Navbar = () => {
  
    // const [isScrolled, setIsScrolled] = useState(false);
    
    //   useEffect(() => {
    //     const handleScroll = () => {
    //       // Check if the vertical scroll position is more than 50 pixels
    //       if (window.scrollY > 50) {
    //         setIsScrolled(true);
    //       } else {
    //         setIsScrolled(false);
    //       }
    //     };
    
    //     // Add the scroll event listener when the component mounts
    //     window.addEventListener('scroll', handleScroll);
    
    //     // Clean up the event listener when the component unmounts
    //     return () => {
    //       window.removeEventListener('scroll', handleScroll);
    //     };
    //   }, []); // The empty array ensures the effect runs only once
    
  return (
    // <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
    <header className="header">
      <div className="logo">
        <a href="/"><span className="logo-text"><img src={PICS.logoFull} alt="logoFull" /></span></a>
      </div>
      <Burger />
    </header>
  )
}

export default Navbar